import { http, HttpResponse } from 'msw'

import { allUsersKonsole } from 'app/mocks/data/users/konsole'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersKonsoleUserApi } from 'app/utils/users/konsole'

import { KonsoleUsersRequest } from 'app/types/users/konsole'

export const getAllUsersKonsole = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.konsole.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilter = searchParams.get(
            searchParametersKonsoleUserApi.MANAGERS,
        )

        const lastNameFilter = searchParams.get(
            searchParametersKonsoleUserApi.LAST_NAME,
        )

        const firstNameFilter = searchParams.get(
            searchParametersKonsoleUserApi.FIRST_NAME,
        )

        const adminFilter = searchParams.get(
            searchParametersKonsoleUserApi.ADMIN,
        )

        let allUsersFiltered = allUsersKonsole

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilter)

            allUsersFiltered = allUsersFiltered.filter((user) =>
                user.profil.client.some((manager) =>
                    managerIdsSplit.includes(manager.id),
                ),
            )
        }

        // Last name filter
        if (lastNameFilter) {
            allUsersFiltered = allUsersFiltered.filter((user) =>
                user.last_name
                    .toLowerCase()
                    .includes(lastNameFilter.toLowerCase()),
            )
        }

        // First name filter
        if (firstNameFilter) {
            allUsersFiltered = allUsersFiltered.filter((user) =>
                user.first_name
                    .toLowerCase()
                    .includes(firstNameFilter.toLowerCase()),
            )
        }

        // Filter is admin
        if (adminFilter) {
            const isAdminValue = adminFilter === 'true'

            allUsersFiltered = allUsersFiltered.filter(
                (user) => user.is_staff === isAdminValue,
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allUsersFiltered.length > limit
                ? offset + limit
                : allUsersFiltered.length

        const results = allUsersFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allUsersFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<KonsoleUsersRequest>({
            next,
            results,
        })
    },
)
